import React from 'react';
import {getIcon} from '../helpers';

class Thumbnail extends React.Component {


    render() {

        let {
            id,
            permalink,
            featured_image,
            excerpt,
            title,
            icon
        } =  this.props.location;

        return (
            <div className={this.props.selected ? "card py-3 px-4 bg-light" : "card py-3 px-4"} onClick={() => this.props.updateSelection(id)}>
                <div className="row">
                    <div className={featured_image ? "col-8" : "col-12"}>
                        <h6 className="text-uppercase font-weight-bold">
                            <i className={"fa attr solid circle-icon bd-mr-2 mb-2 bg-secondary fa-"+icon }></i>
                            <span className="text-body" >
                                {title}
                            </span>
                        </h6>

                        <p className="card-text text-sm text-justify text-black-50">
                            {excerpt}
                        </p>
                    </div>
                    {
                        featured_image ?
                            <div className="col-4">
                                <img src={featured_image} className="img-fluid" alt={title}/>
                            </div>
                            : null
                    }

                </div>
            </div>
        )
    }
}

export default Thumbnail;
